import { fetchAPI } from "packs/api";

function spawnConfetti(element, color) {
    const rect = element.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const particleCount = 12;
    const shapes = ["circle", "rect"];

    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement("span");
        const shape = shapes[Math.floor(Math.random() * shapes.length)];
        const size = 4 + Math.random() * 4;
        const angle = (Math.PI * 2 * i) / particleCount + (Math.random() - 0.5) * 0.5;
        const velocity = 30 + Math.random() * 40;
        const dx = Math.cos(angle) * velocity;
        const dy = Math.sin(angle) * velocity;
        const rotation = Math.random() * 360;

        Object.assign(particle.style, {
            position: "fixed",
            left: cx + "px",
            top: cy + "px",
            width: size + "px",
            height: shape === "rect" ? size * 0.6 + "px" : size + "px",
            backgroundColor: color,
            borderRadius: shape === "circle" ? "50%" : "1px",
            pointerEvents: "none",
            zIndex: "9999",
            opacity: "1",
            transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
            transition: "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.6s ease-out",
        });

        document.body.appendChild(particle);

        // Trigger animation on next frame
        requestAnimationFrame(() => {
            particle.style.transform = `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${rotation + 200}deg)`;
            particle.style.opacity = "0";
        });

        setTimeout(() => particle.remove(), 650);
    }
}

document.addEventListener("click", function (event) {
    const button = event.target.closest(".topic_vote_up, .topic_vote_down");
    if (!button) return; // Ignore clicks outside of vote buttons

    const topicLink = button.dataset.tlink;
    const forumType = button.dataset.ftype;
    const isVoteUp = button.classList.contains("topic_vote_up");
    const voteType = isVoteUp ? "voteup" : "votedown";

    // Confetti burst from the clicked arrow
    const rootStyles = getComputedStyle(document.documentElement);
    const confettiColor = rootStyles.getPropertyValue(isVoteUp ? "--color-highlight-red" : "--color-highlight-blue").trim();
    spawnConfetti(button, confettiColor);

    // Find the container and sibling vote button
    const container = button.closest(".common-box");
    if (container) {
        // Fade out sibling vote buttons, but skip if they are persistent (e.g. admin can vote repeatedly)
        const allVoteBtns = container.querySelectorAll(".topic_vote_up, .topic_vote_down");
        allVoteBtns.forEach((btn) => {
            if (btn !== button && !btn.classList.contains("vote-persistent")) {
                btn.classList.add("vote-fade-out");
            }
        });

        // Animate the clicked arrow with circular motion and disable hover effect
        button.classList.remove("hover:translate-y-1", "hover:-translate-y-1", "transition-all");
        button.classList.add(isVoteUp ? "vote-animate-up" : "vote-animate-down");

        // Swap hollow arrow to filled at the midpoint (when arrow is off-screen)
        const hollowSvg = button.querySelector(".vote-svg-hollow");
        const filledSvg = button.querySelector(".vote-svg-filled");
        if (hollowSvg && filledSvg) {
            // 26% of 850ms = ~221ms is when the arrow reappears from the other side
            setTimeout(() => {
                hollowSvg.classList.add("hidden");
                filledSvg.classList.remove("hidden");
            }, 220);
        }

        // Glow the container border
        container.classList.add(isVoteUp ? "vote-glow-red" : "vote-glow-blue");

        // Glow the hotness number
        const hotnessValue = container.querySelector("[class*='hotness_value_']");
        if (hotnessValue) {
            hotnessValue.classList.add(isVoteUp ? "vote-text-glow-red" : "vote-text-glow-blue");
        }
    }

    // Select all topic votes
    document.querySelectorAll(".topic_vote").forEach((el) => {
        el.style.transition = "opacity 0.6s";
        el.style.opacity = "0.33";
        el.style.cursor = "default";
    });

    fetchAPI(`/${forumType}/${topicLink}/${voteType}`, "POST", {}, "script").catch(() => {
        // Wait for animations to finish (0.85s) before reverting optimistic UI
        setTimeout(() => {
            if (container) {
                container.querySelectorAll(".topic_vote_up, .topic_vote_down").forEach((btn) => {
                    btn.classList.remove("vote-fade-out");
                });
                button.classList.remove(isVoteUp ? "vote-animate-up" : "vote-animate-down");
                button.classList.add("hover:translate-y-1", "hover:-translate-y-1", "transition-all");
                const hollowSvg = button.querySelector(".vote-svg-hollow");
                const filledSvg = button.querySelector(".vote-svg-filled");
                if (hollowSvg && filledSvg) {
                    hollowSvg.classList.remove("hidden");
                    filledSvg.classList.add("hidden");
                }
                container.classList.remove(isVoteUp ? "vote-glow-red" : "vote-glow-blue");
                const hotnessValue = container.querySelector("[class*='hotness_value_']");
                if (hotnessValue) {
                    hotnessValue.classList.remove(isVoteUp ? "vote-text-glow-red" : "vote-text-glow-blue");
                }
            }
            document.querySelectorAll(".topic_vote").forEach((el) => {
                el.style.transition = "";
                el.style.opacity = "";
                el.style.cursor = "";
            });
        }, 850);
    });
});

// Track Hot/Cold vote-prompt clicks via Yandex Metrica reachGoal (Pepper only).
// Guarded to the yandex_metrica provider on purpose: on Desidime (GTM) the same
// clicks are already captured by GTM's native Click trigger on the gtm_ux_vote_prompt_*
// classes, so firing analyticsTrack there would push a redundant dataLayer event.
// closest() handles clicks landing on the inner icon/label.
document.addEventListener("click", function (e) {
    if (!window.appconfig || window.appconfig.analytics_provider !== "yandex_metrica") return;
    const btn = e.target.closest(".gtm_ux_vote_prompt_hot, .gtm_ux_vote_prompt_cold");
    if (!btn) return;
    const vote = btn.classList.contains("gtm_ux_vote_prompt_hot") ? "hot" : "cold";
    if (typeof window.analyticsTrack === "function") {
        window.analyticsTrack("vote_prompt", { vote: vote, deal_id: btn.getAttribute("data-gtm-deal-id") });
    }
});
